import { safeZone, TIME_ZONE_COOKIE } from "@commerce/components/time-zone";
import { createServerFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";

/** Sidebar open state from the cookie the Sidebar writes, so SSR matches. */
export const getSidebarOpenFn = createServerFn({ method: "GET" }).handler(
	() => getCookie("sidebar_state") !== "false",
);

/**
 * The timezone the panel renders every date in, from the cookie the shell
 * writes on a first visit. Read on the server so SSR and the browser format
 * the same instant identically; UTC until the cookie exists.
 */
export const getTimeZoneFn = createServerFn({ method: "GET" }).handler(() =>
	safeZone(getCookie(TIME_ZONE_COOKIE)),
);
